<template>
    <div class="bg-navy text-white font-book rounded-md shadow p-6 divide-y divide-white divide-opacity-10">
        <div class="pb-4">
            <h2 class="text-lg uppercase mb-2">
                Your Customized Service
            </h2>
        </div>
        <div class="py-4">
            <h3 class="mb-2 text-lg">
                Total Monthly Charges
            </h3>
            <div class="bg-navy-dark p-4 pb-2 text-sm divide-y divide-white divide-opacity-10 flex flex-col gap-2">
                <div v-for="serviceType in filteredServiceTypes" :key="serviceType">
                    <div v-if="services[serviceType].length || hasAddOns(serviceType)"
                        :class="{'mt-3' : serviceType !== 'internet'}">
                        <span v-if="hasAddOns(serviceType)" class="font-bold mb-2 mt-3">
                            {{ getServiceType(serviceType) }}
                            <a v-if="currentRouteName !== `buyflow-${serviceType}` && !editIsHidden" class="text-salmon underline ml-1"
                                @click.prevent="$emit('on-edit-click', { name: `buyflow-${serviceType}` })">
                                edit
                            </a>
                        </span>
                        <div v-for="service in services[serviceType]" :key="service.name" class="flex-spread-h
                                    mb-2
                                    ml-2">
                            {{ nameFilter(service.name) }}
                            <span v-if="serviceType === 'internet' && service.promoPrice === 0">{{
                                toCurrency(cartData.promoPriceTotal - cartData.firstMonthTotal - cartData.taxes + 10)
                                }}</span>
                            <span v-else>{{ toCurrency(service.promoPrice) }}</span>
                        </div>

                        <div v-if="serviceType === 'internet'" class="ml-2 mb-2 flex-spread-h">
                            <span>AutoPay & EcoSave sign-up required for discount
                                <AppModal>
                                    <template #trigger>
                                        <button aria-label="Info Icon">
                                            <IconCircleInfo class="inline -mt-1" />
                                        </button>
                                    </template>
                                    <template #contents>
                                        <div class="text-base
                                                    font-bold
                                                    mb-2">
                                            $10 AutoPay &amp; EcoSave Discount
                                        </div>
                                        <div class="text-sm
                                                    font-normal
                                                    break-words">
                                            Enrollment in automatic payments (AutoPay) and paperless billing (EcoSave) is required,
                                            otherwise monthly service charge will automatically increase by the amount of the
                                            discount. A total discount of up to $10 per month will apply when you enroll in both
                                            AutoPay & EcoSave (paperless billing). Customers enrolled in AutoPay & EcoSave will
                                            receive one $10 discount per month when paying with an ACH Checking or Savings account,
                                            or one $5 discount per month when paying with a credit card or debit card, regardless of
                                            the number of subscribed services. Enrollment requires creating a Breezeline My Account,
                                            which can be completed after installation. The discount will appear on your statement
                                            within 45 days of enrollment. Additional terms and conditions apply; please see the
                                            Residential Subscriber Agreement for details. <strong>Failure to enroll in AutoPay &
                                                EcoSave or discontinuation will result in the removal of the monthly AutoPay &
                                                EcoSave discount.</strong>
                                        </div>
                                    </template>
                                </AppModal>
                            </span>
                            <span>-$10.00</span>
                        </div>

                        <div v-for="(items, index) in addOns[serviceType]" :key="index">
                            <div v-for="item in items" :key="item.name" class="flex-spread-h">
                                <span v-if="!['Internet + TV Discount'][item.name]" class="ml-2 mb-2">

                                    {{ nameFilter(item.name) }}
                                    <span v-if="item.quantity > 1" class="bg-salmon text-white mx-1 px-1.5 rounded-full font-normal">
                                        {{ item.quantity }}
                                    </span>
                                </span>
                                <span v-if="!['Internet + TV Discount'][item.name]">
                                    {{ toCurrency(item.promoPrice, false) }}
                                </span>
                            </div>
                        </div>

                        <div v-if="serviceType === 'tv' && cartData.addOns.tv.base[1] && ['Internet + TV Discount'][cartData.addOns.tv.base[1].name]"
                            class="flex justify-between ml-2 mb-2">
                            <span>
                                {{cartData.addOns.tv.base[1].name}}
                            </span>
                            <span v-if="cartData.addOns.tv.base[1].promoPrice">
                                -{{toCurrency(cartData.addOns.tv.base[1].promoPrice)}}
                            </span>
                        </div>

                        <div v-if="serviceType === 'internet' && mobileEligible && mobileInterested"
                            class="flex justify-between ml-2 mb-2">
                            <div class="inline">
                                Internet + Mobile Discount
                                    <AppModal>
                                        <template #trigger>
                                            <button aria-label="Info Icon">
                                                <IconCircleInfo class="inline text-sm -mt-1" />
                                            </button>
                                        </template>
                                        <template #contents>
                                            <div class="text-base
                                                    font-bold
                                                    mb-2">
                                                Includes Breezeline Mobile Discount
                                            </div>
                                            <div class="text-base text-left mb-2">
                                                A discount of $5 per month will apply when you enroll with Breezeline Mobile. An additional
                                                $5 per month will be applied if you also have TV or Home Phone services on your account (for
                                                a total discount of $10). Discount will be applied one billing cycle after activation of
                                                Mobile Service and HSD Service. Termination of service will result in removal of applicable
                                                discount(s).
                                            </div>
                                        </template>
                                    </AppModal>
                                <button class="underline" @click="removeFromMobilePlan">remove</button>
                            </div>
                            <span>
                                {{ mobileDiscountAmount }}
                            </span>
                        </div>

                        <div v-if="serviceType === 'tv' && mobileEligible && mobileInterested"
                            class="flex justify-between ml-2 mb-2">
                            <div class="inline">
                                TV + Mobile Discount
                                <AppModal>
                                    <template #trigger>
                                        <button aria-label="Info Icon">
                                            <IconCircleInfo class="inline text-sm -mt-1" />
                                        </button>
                                    </template>
                                    <template #contents>
                                        <div class="text-base
                                                font-bold
                                                mb-2">
                                            Includes Breezeline Mobile Discount
                                        </div>
                                        <div class="text-base text-left mb-2">
                                            A discount of $5 per month will apply when you enroll with Breezeline Mobile. An additional
                                            $5 per month will be applied if you also have TV or Home Phone services on your account (for
                                            a total discount of $10). Discount will be applied one billing cycle after activation of
                                            Mobile Service and HSD Service. Termination of service will result in removal of applicable
                                            discount(s).
                                        </div>
                                    </template>
                                </AppModal>
                                <button class="underline ml-2" @click="removeFromMobilePlan">remove</button>
                            </div>
                            <span>
                                {{ mobileDiscountAmount }}
                            </span>
                        </div>

                        <div v-else-if="serviceType === 'voice' && !isTvSelected && mobileEligible && mobileInterested"
                            class="flex justify-between ml-2 mb-2">
                            <div class="inline">
                                Home Phone + Mobile Discount
                                <AppModal>
                                    <template #trigger>
                                        <button aria-label="Info Icon">
                                            <IconCircleInfo class="inline text-sm -mt-1" />
                                        </button>
                                    </template>
                                    <template #contents>
                                        <div class="text-base
                                                font-bold
                                                mb-2">
                                            Includes Breezeline Mobile Discount
                                        </div>
                                        <div class="text-base text-left mb-2">
                                            A discount of $5 per month will apply when you enroll with Breezeline Mobile. An additional
                                            $5 per month will be applied if you also have TV or Home Phone services on your account (for
                                            a total discount of $10). Discount will be applied one billing cycle after activation of
                                            Mobile Service and HSD Service. Termination of service will result in removal of applicable
                                            discount(s).
                                        </div>
                                    </template>
                                </AppModal>
                                <button class="underline ml-2" @click="removeFromMobilePlan">remove</button>
                            </div>
                            <span>
                                {{ mobileDiscountAmount }}
                            </span>
                        </div>

                        <div v-else-if="mobileEligible && !mobileInterested"
                            class="flex justify-between ml-2 mb-2 font-bold">
                            Mobile Discount Eligible
                            <button class="underline text-salmon" @click="addToMobilePlan">add</button>
                        </div>

                        <div v-else-if="mobileInterested && !mobileEligible" class="ml-2">
                            Interested in Breezeline Mobile
                        </div>

                        <div v-if="serviceType === 'internet'" class="flex justify-end font-bold">
                            ${{ (combinedServiceAndAddons(services[serviceType], addOns[serviceType]) - 10).toFixed(2)
                            }}
                        </div>
                        <div v-else class="flex justify-end font-bold">
                            ${{ combinedServiceAndAddons(services[serviceType], addOns[serviceType]) }}
                        </div>
                    </div>
                </div>
                <div class="pt-3">
                    <span class="font-bold">Taxes</span>
                    <div class="ml-2 mb-2 flex-spread-h">
                        <span>Estimated local tax
                            <AppModal>
                                <template #trigger>
                                    <button aria-label="Info Icon">
                                        <IconCircleInfo class="inline -mt-1" />
                                    </button>
                                </template>
                                <template #contents>
                                    <div class="text-sm
                                                font-normal
                                                break-words">
                                        Will be included when order is completed
                                    </div>
                                </template>
                            </AppModal>
                        </span>

                        <span>{{ toCurrency(cartData.taxes) }}</span>
                    </div>
                </div>
                <div class="flex text-lg font-bold justify-between pt-3">
                    <span>Monthly Bill</span> <span>{{toCurrency(cartData.promoPriceTotal - totalMobileDiscount
                        )}}</span>
                </div>
            </div>
        </div>
        <div class="py-4">
            <div class="flex-spread-h mb-2">
                <h3 class="text-lg">
                    Your First Bill
                </h3>
            </div>
            <div class="bg-navy-dark p-4 pb-2 text-sm">
                <div class="flex font-bold mb-2 justify-between">
                    <span>Monthly Charges</span>
                    <span>{{toCurrency(cartData.promoPriceTotal - totalMobileDiscount)}}</span>
                </div>


                <div v-for="serviceType in ['installation']" :key="serviceType">
                    <span v-if="hasAddOns(serviceType)" class="font-bold mb-2 mt-3">
                        {{!isOhio ? 'One-Time Charges' : '' }}

                    </span>
                    <div v-for="(items, index) in addOns[serviceType]" :key="index">
                        <div v-for="item in items" :key="item.name" class="mb-2">
                            <span :class="selfInstallQuizCheck()">
                                <span>
                                    {{ nameFilter(item.name) }}
                                    <span v-if="item.quantity > 1" class="bg-salmon text-white mx-1 pl-1.5 pr-1 rounded-full font-normal">
                                        {{ item.quantity }}
                                    </span>
                                </span>
                                <span class="font-bold">{{ toCurrency(item.promoPrice, false) }}</span>
                            </span>

                        </div>
                    </div>

                    <div v-if="appliedPromotions && Object.keys(appliedPromotions).length > 0" class="mb-2 mt-3">
                        <span v-if="hasAddOns(serviceType)" class="font-bold mb-2 mt-3">
                            One-Time Promotions
                        </span>
                        <div v-for="(promotion, key) in appliedPromotions" :key="key" class="flex-spread-h mb-2">
                            <span class="ml-2">
                                {{ getPromoLabel(key) }}
                            </span>
                            <span
                                class="uppercase relative mb-2 tracking-wide text-3xs desktop:text-xs rounded-lg bg-salmon px-2 py-1
                                text-black block text-center font-bold desktop:mb-0">
                                &#9733; {{ getPromoPrice(key) }}
                            </span>
                        </div>
                    </div>

                    <div class="flex text-lg font-bold justify-between border-t border-white border-opacity-10 pt-2">
                        <span class="">First Month</span>
                        <div>
                            <span>{{ toCurrency(cartData.firstMonthTotal) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-4">
            <div class="text-right">
                <div>
                    <span class="text-lg mobile:text-xl tablet:text-lg widescreen:text-xl">
                        <span class="font-book">After that you'll pay:</span>
                        <span v-if="fmfAmount" class="font-bold">{{ toCurrency(cartData.promoPriceTotal + fmfAmount -
                            discountAmount - totalMobileDiscount) }}</span>
                        <span v-else class="font-bold">{{ toCurrency(cartData.promoPriceTotal - discountAmount -
                            totalMobileDiscount) }}</span>
                    </span>

                    <span class="text-sm">
                        /mo
                    </span>
                </div>
                <span class="text-sm">
                    Price guaranteed for the next {{ promoDuration }} months
                </span>
                <AppModal>
                    <template #trigger>
                        <button aria-label="Info Icon">
                            <IconCircleInfo class="inline text-sm -mt-1" />
                        </button>
                    </template>
                    <template #contents>
                        <div class="text-base text-left font-bold mb-2">
                            {{(promoDuration)}} month promotion price.
                        </div>
                        <div class="text-sm text-left font-normal break-words">
                            <div v-if="isTvSelected">Everyday price after promotion:
                                <span v-if="isWowMarket || isOhio">
                                    <!-- Change the 15 to a 5 after Jan Offer -->
                                    {{toCurrency(cartData.fullPriceTotal - edpDiscountAmount - 5 -
                                    totalMobileDiscount)}}/mo
                                </span>
                                <span v-else>
                                    <!-- Remove the -10 after Jan Offer -->
                                    {{toCurrency(cartData.fullPriceTotal - edpDiscountAmount - totalMobileDiscount)}}/mo
                                </span>
                            </div>
                            <span v-if="isWowMarket">
                                Free Gateway and WiFi Your Way&trade; Home rental for 12 months ($14.99/mo value).
                            </span>
                            <div v-else>Promotional periods for equipment rental may differ from other services.</div>
                        </div>
                    </template>
                </AppModal>
            </div>

            <div class="uppercase font-bold text-right">
                No contract. Cancel anytime.
            </div>
            <div class="text-sm flex justify-end">
                <div>
                    <span class="text-xs mobile:text-sm tablet:text-xs widescreen:text-sm"> Includes up to $10 AutoPay &
                        EcoSave Discount</span>
                </div>
            </div>

            <div v-if="hasAppliedPromotion && getPromoFootnote && getPromoFootnote.trim()" class="text-sm text-right mt-2">
                <div class="inline-block">
                    {{ getPromoFootnote }}
                    <AppModal v-if="getPromoDisclaimer && getPromoDisclaimer.trim()">
                        <template #trigger>
                            <button aria-label="Info Icon">
                                <IconCircleInfo class="inline text-sm -mt-1" />
                            </button>
                        </template>
                        <template #contents>
                            <div class="text-sm text-left font-normal break-words">
                                {{ getPromoDisclaimer }}
                            </div>
                        </template>
                    </AppModal>
                </div>
            </div>

        </div>
        <div class="hidden
                    pt-text-right 4
                ">
            <h6 class="uppercase
                       text-yellow">
                Straight up pricing
            </h6>
            <p class="text-sm
                      mb-4">
                Besides regulatory fees and taxes beyond our control, all fees are included so you know what your bill
                will look like next month, next year, and beyond.
            </p>
        </div>
    </div>
</template>

<script>
    import ToggleSwitch from "@/atoms/ToggleSwitch"
    import AppModal from "~/Buyflow/components/AppModal"
    import { mapActions, mapState, mapGetters } from "vuex"
    import IconCircleInfo from "@/atoms/icons/IconCircleInfo"
    import products from "../../../../templates/products/_products";

    export default {
        name: 'AppCart',
        components: {
            ToggleSwitch,
            AppModal,
            IconCircleInfo,
        },
        props: {
            cartData: {
                type: Object,
                required: true,
            },
            currentRouteName: {
                type: String,
                required: true,
            },
            productMetadata: {
                type: String,
                required: false,
                default: "[]",
            },
            editIsHidden:{
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                mobileDiscountAmount: `-$5.00`,
            }
        },
        computed: {
            ...mapState({
                meta: state => state.meta,
                dropStatus: state => state.Buyflow.dropStatus,
                finalizeState: state => state.Buyflow.finalize.finalizeState,
                mobileEligible: state => state.Buyflow.mobileEligible,
				mobileInterested: state => state.Buyflow.mobileInterested,
                appliedPromotions: state => state.Promotions.appliedPromotions,
                isAbandonedCart: state => state.meta.isAbandonedCart,
                selectedGiftOption: state => state.Promotions.selectedGiftOption
            }),
            ...mapGetters({
                isFmf: 'isFmf',
                isGwp: 'isGwp',
                fmfAmount: 'fmfAmount',
                gwpAmount: 'gwpAmount',
                isFeatureSet: 'isFeatureSet',
                parseMetadata: 'parseMetadata',
                filterAndMerge: 'filterAndMerge',
                discountAmount: 'discountAmount',
                isWowMarket: 'Buyflow/isWowMarket',
                isFiber: 'Buyflow/internet/isFiber',
                edpDiscountAmount: 'edpDiscountAmount',
                sectionStatus: 'Buyflow/sectionStatus',
                hasGiftCard: 'Buyflow/receipt/hasGiftCard',
                giftCardName: 'Buyflow/receipt/giftCardName',
                internet: 'Buyflow/internet/selectedService',
                giftCardPrice: 'Buyflow/receipt/giftCardPrice',
                promoPrice: 'Buyflow/receipt/promoPrice',
                selectedService: 'Buyflow/internet/selectedService',
                isSelfInstallEligible: 'Buyflow/finalize/isSelfInstallEligible',
            }),
            ...mapGetters({
                multipleChoicePromo: 'Promotions/multipleChoicePromo',
                hasMultipleChoicePromo: 'Promotions/hasMultipleChoicePromo'
            }),
            ...mapGetters('Buyflow',[
                'isOhio',
            ]),
            hasAppliedPromotion() {
                return this.appliedPromotions && Object.keys(this.appliedPromotions).length > 0;
            },
            getPromoFootnote() {
                if (!this.hasAppliedPromotion) return '';

                if (this.multipleChoicePromo) {
                    if (!this.selectedGiftOption) {
                        return '';
                    } else {
                        // Find the matching gift option from the multipleChoicePromo
                        const selectedOption = this.multipleChoicePromo.gift_options.find(
                            option => option.key === this.selectedGiftOption
                        );

                        if (selectedOption) {
                            if (selectedOption.cart_footNote) {
                                return selectedOption.cart_footNote;
                            }
                        }
                        return '';
                    }
                } else {
                    const promotionKey = Object.keys(this.appliedPromotions)[0];
                    const promotion = this.appliedPromotions[promotionKey];

                    // Get the cart_footNote UI element from the promotion
                    return promotion?.product?.ui_elements?.find(ui => ui.key === 'cart_footNote')?.text || '';
                }
            },
            getPromoDisclaimer() {
                if (!this.hasAppliedPromotion) return '';

                if (this.multipleChoicePromo) {
                    if (!this.selectedGiftOption) {
                        return '';
                    } else {
                        // Find the matching gift option from the multipleChoicePromo
                        const selectedOption = this.multipleChoicePromo.gift_options.find(
                            option => option.key === this.selectedGiftOption
                        );

                        if (selectedOption) {
                            if (selectedOption.cart_footNoteInfo) {
                                return selectedOption.cart_footNoteInfo;
                            }
                        }
                        return '';
                    }
                } else {
                    const promotionKey = Object.keys(this.appliedPromotions)[0];
                    const promotion = this.appliedPromotions[promotionKey];

                    // Get the cart_footNoteInfo UI element from the promotion
                    return promotion?.product?.ui_elements?.find(ui => ui.key === 'cart_footNoteInfo')?.text || '';
                }
            },
            productData () {
                return {
                    file: this.parseMetadata(products ?? []),
                    craft: this.parseMetadata(JSON.parse(this.productMetadata) ?? [])
                }
            },
            mergedMetadata() {
                return this.filterAndMerge({base: this.productData.file, override: this.productData.craft})
            },
            services () {
                return this.cartData?.services
            },
            addOns () {
                return this.cartData?.addOns
            },
            promoDuration(){
                const data = this.mergedMetadata[this.internet.name][0]
                return (data?.variants?.customizations?.internet?.products[this.internet.name]?.promoMonths || "12").split(',')[0]
            },
            promoGiftcard(){
                const data = this.mergedMetadata[this.internet.name][0]
                const price = data?.variants?.customizations?.internet?.products[this.internet.name]?.banner?.price;
                return price ? price :  ''
            },
            filteredServiceTypes() {
                return ['internet', 'tv', 'voice'].filter(item => (this.services[item].length || this.hasAddOns(item)))
            },
            isTvSelected() {
                return this.services?.tv.length > 0
            },
            isVoiceSelected() {
                return this.services?.voice.length > 0
            },
            totalMobileDiscount() {
                return this.mobileEligible && this.mobileInterested ? (this.isTvSelected || this.isVoiceSelected ? 10 : 5) : 0
            },
        },
        methods: {
            ...mapActions({
                setFinalizeState: 'Buyflow/finalize/setFinalizeState',
                clearScheduledInstall: 'Buyflow/finalize/clearScheduledInstall',
                setMobileInterested: 'Buyflow/setMobileInterested',
            }),
            hasAddOns (type) {
                for (let key in this.addOns[type]) {
                    if (Array.isArray(this.addOns[type][key]) && this.addOns[type][key].length > 0) {
                        return true;
                    }
                }
                return false
            },
            getServiceType (type) {
                return {
                    internet: 'Internet',
                    tv: 'TV',
                    voice: 'Home Phone',
                }[type]
            },
            nameFilter(name) {
                return {
                    'SIK - Tech Deliver': 'Self Installation Kit',
                    'SIK - Ship Direct': 'Self Installation Kit',
                    'WiFi Your Way -  2 WiFi 6 Extenders': 'WiFi Your Way -  2 WiFi 6 Extenders',
                    'WYW OpenSync - WiFi 6 Extender' : 'WiFi Your Way&trade; Home',
                    'WiFi Your Way - WiFi 6 Router' : 'WiFi Your Way&trade; Home',
                    'WiFi Your Way - WiFi 6 Router & WiFi 6 Extender' : 'WiFi Your Way&trade; Home',
                    'Gateway Lease': this.isFiber ? 'High-Speed Fiber Modem Lease' : 'High-Speed Modem Lease',
                    "Add'l WiFi 6 Extender": "Add'l WiFi Extender",
					"Unlimited Voice Service":"Unlimited Home Phone Service",
                }[name] || name
            },
            combinedServiceAndAddons(service, addons, serviceType){
                let value = 0;

                service.forEach(item => {
                    value += item.promoPrice
                });

                for(let i in addons){
                    addons[i].forEach(item => {
                        value += item.promoPrice
                    })
                }

                if (!(this.isTvSelected && serviceType === 'voice')) {
                    value -= this.totalMobileDiscount ? 5 : 0
                }

                return value.toFixed(2);
            },
            selfInstallQuizCheck() {
                if( this.finalizeState.selfInstall !== 'completed' && this.isSelfInstallEligible !== false ) {
                    return 'hidden'
                } else {
                    return 'flex-spread-h'
                }
            },
            addToMobilePlan() {
                this.setMobileInterested(!this.mobileInterested)
                this.sendEvent('resi:checkout', null,  null, 'checkout_mobile_eligible_add_mobile_receipt_cta')
            },
            removeFromMobilePlan() {
                this.setMobileInterested(!this.mobileInterested)
                this.sendEvent('resi:checkout', null,  null, 'checkout_mobile_eligible_remove_mobile_receipt_cta')
            },
            getPromoLabel(promotionKey) {
                if(this.multipleChoicePromo) {
                    return `${this.selectedService.name} offer`;
                } else {
                    const promotion = this.appliedPromotions[promotionKey];
                    return promotion?.product?.ui_elements?.find(ui => ui.key === 'cart_oneTime_label')?.text;
                }
            },
            getPromoPrice(promotionKey) {
                if(this.multipleChoicePromo) {
                    if(!this.selectedGiftOption) {
                        return 'Promotion Available'
                    } else {
                        // Find the matching gift option from the multipleChoicePromo
                        const selectedOption = this.multipleChoicePromo.gift_options.find(
                            option => option.key === this.selectedGiftOption
                        );

                        if(selectedOption) {
                            if(selectedOption.promoType === 'giftcard') {
                                return `$${selectedOption.amount} Gift Card`;
                            } else if(selectedOption.promoType === 'free_months') {
                                return `${selectedOption.months} ${selectedOption.months > 1 ? 'Months' : 'Month'} Free`;
                            }
                            return selectedOption.displayText;
                        }
                        return 'Selected Promotion';
                    }
                } else {
                    const promotion = this.appliedPromotions[promotionKey];
                    return promotion?.product?.ui_elements?.find(ui => ui.key === 'cart_oneTime_price')?.text;
                }
            }
        }
    }
</script>
